// /src/pages/parallel/ParallelTopicPage.js
import { useNavigate } from "react-router-dom";
import { useParallelPersona } from "../../context/ParallelPersonaContext";
import { useState } from "react";
import Header from "../../components/Header";
import "../../styles/ParallelTopicPage.css";

const topics = {
  1: "Activities carried out using digital health services",
  2: "Type of digital service used for contacting GP",
  3: "Concerns about communicating with GP via digital services",
  4: "Type of Energy Used at Home",
  5: "Managing Household Energy Using Digital Services",
  6: "Type of uses of digital services for energy",
  7: "Concerns about using digital services for energy",
  8: "Current type of accommodation",
  9: "Experience or interest in looking for social housing",
  10: "Concerns about digital services for social housing",
  11: "Type of use of digital services for housing activities",
};

const ParallelTopicPage = () => {
  const { setTopics } = useParallelPersona();
  const navigate = useNavigate();
  const [selectedTopics, setSelectedTopics] = useState([]);

  const handleSelect = (key) => {
    setSelectedTopics((prev) =>
      prev.includes(key) ? prev.filter((item) => item !== key) : [...prev, key]
    );
  };

  const handleNext = () => {
    setTopics(selectedTopics);
    navigate("/parallel/confirm");
  };

  return (
    <div className="parallel-topic-page">
      <Header />
      <h2 className="page-title">Select Topics</h2>
      <p>The app found these topics in the survey dataset</p>
      <div className="topics-list">
        {Object.entries(topics).map(([key, value]) => (
          <label key={key}>
            <input
              type="checkbox"
              value={key}
              onChange={() => handleSelect(parseInt(key))}
              checked={selectedTopics.includes(parseInt(key))}
            />
            {value}
          </label>
        ))}
      </div>
      <p>
        Select topics from the above which you want to generate personas from.
        <br />
        Selecting more topics will give better and more complex personas.
      </p>
      <div className="navigation-buttons">
        <button
          className="back-button"
          onClick={() => navigate("/parallel/ethnicity")}
        >
          Back
        </button>
        <button
          className="next-button"
          onClick={handleNext}
          disabled={selectedTopics.length === 0}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ParallelTopicPage;
